import jspdf from 'jspdf'

import { formatDate } from './utils'

import image from '../assets/DPC.jpg'

export function createPdfForCandidates(candidates) {
  var doc = new jspdf('p', 'pt')
  

  for (let candidateIndex in candidates) {
    let candidate = candidates[candidateIndex]
    addCandidateToPdf(doc, candidate)

    if (candidateIndex < (candidates.length - 1)) {
      doc.addPage()
    }
  }
  doc.save('Candidate-Details.pdf')
}

const increaseYPosition = (yPosition, height, doc) => {
  let pageMaxHeight = 800
  let startingYPosition = 60

  yPosition = yPosition + height

  // if bottom of the page is reached then start a new page and reset y position
  if (yPosition >= pageMaxHeight) {
    doc.setFontType("italic")
    doc.setTextColor('#000000')
    doc.text('Sensitive:Personal-I1-A1', 250, yPosition)
    doc.addPage()
    yPosition = startingYPosition
  }

  return yPosition
}


const addCandidateToPdf = (doc, candidate) => {
  let yPosition = 50
  let standardXPosition = 30
  let rightXPosition = 200
  let lineSpacing = 20  

  doc.addImage(image, 'JPG', 350, 10, 230, 60)

  doc.setFontSize(20)
  doc.setFontType("bold")
  doc.text('BoardingCall Profile', standardXPosition, yPosition)

 /* yPosition = increaseYPosition(yPosition, 30, doc)

  doc.setFontSize(20)
  doc.setFontType("bold")
  doc.text('CANDIDATE PROFILE REPORT', standardXPosition, yPosition)*/

  yPosition = increaseYPosition(yPosition, 30, doc)

  doc.setFontSize(12)
  doc.setFontType("bold")
  doc.text('Personal Information', standardXPosition, yPosition)

  yPosition = increaseYPosition(yPosition, lineSpacing, doc)

  doc.setFontType("normal")
  doc.text('Full Name:', standardXPosition, yPosition)

  let title = candidate.Title ? candidate.Title + ' ' : ''
  let middleNames = candidate.MiddleNames ? candidate.MiddleNames + ' ' : ''
  doc.text(title + candidate.GivenName + " " + middleNames + candidate.FamilyName, rightXPosition, yPosition)

  yPosition = increaseYPosition(yPosition, lineSpacing, doc)

  if (candidate.PreferredName) {
  let preferredName = candidate.PreferredName ? candidate.PreferredName + ' ' : ''
  doc.text("Preferred Name: ", standardXPosition, yPosition)
  doc.text(preferredName, rightXPosition, yPosition)

  yPosition = increaseYPosition(yPosition, lineSpacing, doc)
  }

  doc.text('Gender:', standardXPosition, yPosition)
  let gender = candidate.GenderLookup ? candidate.GenderLookup.Description : ''
  doc.text(gender, rightXPosition, yPosition)

  yPosition = increaseYPosition(yPosition, lineSpacing, doc)

  doc.text('Date of Birth:', standardXPosition, yPosition)
  let dateOfBirth = candidate.DateOfBirth ? formatDate(candidate.DateOfBirth) : ''
  doc.text(dateOfBirth, rightXPosition, yPosition)

  yPosition = increaseYPosition(yPosition, lineSpacing * 2, doc)

  doc.setFontType("bold")
  doc.text('Candidate registration:', standardXPosition, yPosition)
  let applicationDate = candidate.ApplicationDate ? formatDate(candidate.ApplicationDate) : ''
  doc.text(applicationDate, rightXPosition, yPosition)

  yPosition = increaseYPosition(yPosition, lineSpacing * 2, doc)

  doc.text('Identifies As', standardXPosition, yPosition)

  yPosition = increaseYPosition(yPosition, lineSpacing, doc)

  doc.setFontType("normal")
  if (candidate.AboriginalFlag) {
    doc.text('Person of Aboriginal origin', standardXPosition, yPosition)

    yPosition = increaseYPosition(yPosition, lineSpacing, doc)
  }

  if (candidate.WithDisabilityFlag) {
    doc.text('Person with disability', standardXPosition, yPosition)

    yPosition = increaseYPosition(yPosition, lineSpacing, doc)
  }

  if (candidate.CulturalBackgroundFlag) {
    doc.text('Person of culturally/linguistically diverse background', standardXPosition, yPosition)

    yPosition = increaseYPosition(yPosition, lineSpacing, doc)
  }

  if (!candidate.AboriginalFlag && !candidate.WithDisabilityFlag && !candidate.CulturalBackgroundFlag) {
    doc.text('(no data available)', standardXPosition, yPosition)

    yPosition = increaseYPosition(yPosition, lineSpacing, doc)

  }

  yPosition = increaseYPosition(yPosition, lineSpacing, doc)

  doc.setFontType("bold")
  doc.text('Employment', standardXPosition, yPosition)

  yPosition = increaseYPosition(yPosition, lineSpacing, doc)

  doc.setFontType("normal")

  if (candidate.SaGovEmployeeFlag) {
    doc.text('SA Govt employee', standardXPosition, yPosition)

    yPosition = increaseYPosition(yPosition, lineSpacing, doc)
  }

  let jobTitle = candidate.CurrentJobTitle ? candidate.CurrentJobTitle + ' ' : ''
  if (jobTitle) {
    doc.text(jobTitle, standardXPosition, yPosition)

    yPosition = increaseYPosition(yPosition, lineSpacing, doc)
  }

  let employerAddress = candidate.CurrentEmployerNameAndAddress ? candidate.CurrentEmployerNameAndAddress + ' ' : ''
  if (employerAddress) {
    doc.text(employerAddress, standardXPosition, yPosition)

    yPosition = increaseYPosition(yPosition, lineSpacing, doc)
  }

  yPosition = increaseYPosition(yPosition, lineSpacing * 2, doc)

  doc.setFontType("bold")
  doc.text('Board Experience', standardXPosition, yPosition)

  doc.setFontType("normal")
   yPosition = yPosition + lineSpacing
  let boards = candidate.CandidateBoards ? candidate.CandidateBoards.$values : []
  if (boards.length > 0) {
    for (let boardIndex in boards) {
      let board = boards[boardIndex]
      let endYear = board.EndYear?board.EndYear: ''
      let startYear = board.StartYear?board.StartYear: ''
      let durationOnBoard = startYear + " - " + endYear;
      doc.text("Board Name            : " + board.BoardName, standardXPosition, yPosition)
      yPosition = increaseYPosition(yPosition, lineSpacing, doc)
      doc.text("Board Position         : " + board.BoardPosition, standardXPosition, yPosition)
      yPosition = increaseYPosition(yPosition, lineSpacing, doc)
      doc.text("Duration on Board   : " + durationOnBoard, standardXPosition, yPosition)
      yPosition = increaseYPosition(yPosition, lineSpacing, doc)
      yPosition = increaseYPosition(yPosition, lineSpacing, doc)
    }
  } else {
    doc.text('(no data available)', standardXPosition, yPosition)
  }

  yPosition = increaseYPosition(yPosition, lineSpacing * 2, doc)


  doc.setFontType("bold")
  doc.text('Qualifications', standardXPosition, yPosition)

  doc.setFontType("normal")

  let qualifications = candidate.QualificationLookups ? candidate.QualificationLookups.$values : []
  if (qualifications.length > 0) {
    for (let qualificationIndex in qualifications) {
      let qualification = qualifications[qualificationIndex]

      yPosition = increaseYPosition(yPosition, lineSpacing, doc)

      doc.text(qualification.Description, standardXPosition, yPosition)
    }
  } else {
    yPosition = yPosition + lineSpacing

    doc.text('(no data available)', standardXPosition, yPosition)
  }

  yPosition = increaseYPosition(yPosition, lineSpacing * 2, doc)

  doc.setFontType("bold")
  doc.text('Skills and Expertise', standardXPosition, yPosition)

  doc.setFontType("normal")

  let skills = candidate.SkillLookups ? candidate.SkillLookups.$values : []
  if (skills.length > 0) {
    for (let skillIndex in skills) {
      let skill = skills[skillIndex]

      yPosition = increaseYPosition(yPosition, lineSpacing, doc)

      doc.text(skill.Description, standardXPosition, yPosition)
    }
  } else {
    yPosition = yPosition + lineSpacing

    doc.text('(no data available)', standardXPosition, yPosition)
  }

  yPosition = increaseYPosition(yPosition, lineSpacing * 2, doc)

  doc.setFontType("bold")
  doc.text('Contact Details', standardXPosition, yPosition)

  yPosition = increaseYPosition(yPosition, lineSpacing, doc)

  doc.setFontType("normal")
  let address = candidate.Address ? candidate.Address : '(no data available)'

  //Below address adjustment is done to fix text overlapping of addresses with multiple lines
  var adjustedAddress = doc.splitTextToSize(address, 200)
  
  var addressHeight = 0
  for(var i = 0; i < adjustedAddress.length; i++){
      addressHeight += Math.ceil(doc.getTextDimensions(adjustedAddress[i]).h)
  }
   
  doc.text(address, standardXPosition, yPosition)  

  yPosition = increaseYPosition(yPosition, addressHeight, doc)

  let suburb = candidate.Suburb ? candidate.Suburb + ' ' : ''
  let suburbAndSate = suburb + (candidate.State ? candidate.State : '')
  doc.text(suburbAndSate, standardXPosition, yPosition)

  yPosition = increaseYPosition(yPosition, lineSpacing, doc)

  doc.text(candidate.PostCode ? candidate.PostCode : '', standardXPosition, yPosition)

  yPosition = increaseYPosition(yPosition, lineSpacing * 2, doc)

  doc.setFontType("bold")
  doc.text('Preferred Contact Number', standardXPosition, yPosition);

  doc.setFontType("normal")
  doc.text(candidate.ContactNo ? candidate.ContactNo : '', rightXPosition, yPosition)

  yPosition = increaseYPosition(yPosition, lineSpacing, doc)

  doc.setFontType("bold")
  doc.text('Email', standardXPosition, yPosition);

  doc.setFontType("normal")
  doc.text(candidate.Email ? candidate.Email : '', rightXPosition, yPosition)

  yPosition = increaseYPosition(yPosition, lineSpacing, doc)

  doc.setFontType("bold")
  doc.text('LinkedIn', standardXPosition, yPosition);

  doc.setFontType("normal")
  doc.setTextColor('#0000EE')
  if (candidate.LinkedInUrl) {
    doc.textWithLink(candidate.LinkedInUrl, rightXPosition, yPosition, { url: candidate.LinkedInUrl })
  }

//set footer text at the end. 
   if (yPosition >= 800) {
     //we are at the bottom of the page
    doc.setFontType("italic")
    doc.setTextColor('#000000')
    doc.text('Sensitive:Personal-I1-A1', 250, yPosition)
  }else{
    //we are not at the bottom of the page. add footer to bottom of page
      doc.setFontType("italic")
       doc.setTextColor('#000000')
     doc.text('Sensitive:Personal-I1-A1', 250, 800)
  }


  doc.setTextColor('#000000')
}




// WEBPACK FOOTER //
// ./src/js/pdf.js